import { TableRow, TableCell, TableHeaderCell, mergeClasses } from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import { addDays } from "date-fns";
import { Body1Stronger } from "@fluentui/react-components";
import TooltipWatcherWidget from '../TooltipWatcherWidget';
import { Accordion, AccordionItem, AccordionHeader, AccordionPanel } from "@fluentui/react-components";
import { formatDisplayDate } from "../../services/TimeFunctions";


export default function Leave({ leaveData }) {
  const { currentWeekStart, useStyles, isDesktop, dateToggle } = useGlobalStatus();
  const styles = useStyles();
  const dates = Array.from({ length: 7 }, (_, i) => addDays(currentWeekStart, i));

  // Group leave entries by type
  const leaveByType = (leaveData || []).reduce((acc, ld) => {
    if (!acc[ld.type]) acc[ld.type] = [];
    acc[ld.type].push(ld);
    return acc;
  }, {});

  // Convert into a "project with timecodes" structure
  const leaveProject = {
    projectName: "Leave",
    timecodes: Object.keys(leaveByType).map((type) => {
      const entries = leaveByType[type];
      // Compute daily totals
      const dailyTotals = dates.map((date) =>
        entries
          .filter(ld => new Date(ld.date).toDateString() === date.toDateString())
          .reduce((sum, ld) => sum + ld.hours, 0)
      );
      const statuses = dates.map(date => {
        const dayEntries = entries.filter(
          ld => new Date(ld.date).toDateString() === date.toDateString()
        );

        return dayEntries.map(e => e.status);
      });
      // Compute weekly total
      const weekTotal = dailyTotals.reduce((sum, h) => sum + h, 0);

      return {
        timecodeName: type,
        dailyTotals,
        weekTotal,
        statuses
      };
    })
  };

  const getStatusColor = (status) => {
  switch (status) {
    case "Approved":
      return "#8cbeb3" 
    case "Pending":
      return "#fff3cd"; 
    default:
      return "#eeeeee"; 
  }
};

  // Desktop Table
  if (isDesktop) {
    return leaveProject.timecodes.map((tc, index) => (
      <TableRow key={`leave-${tc.timecodeName}`}>
        {index === 0 && (
          <TableHeaderCell rowSpan={leaveProject.timecodes.length} style={{ fontWeight: "bold" }}>
            <TooltipWatcherWidget text="Hours of leave. Yellow = pending, green = approved" direction="above-start">
              <span>Leave</span>
            </TooltipWatcherWidget>
          </TableHeaderCell>
        )}
        <TableCell style={{ backgroundColor: "#eff1f5" }}>{tc.timecodeName}</TableCell>
        {tc.dailyTotals.map((hours, i) => {
          const status = tc.statuses[i][0];
          const bgColour = getStatusColor(status);
          return (
            <TableCell key={i} style={{ backgroundColor: bgColour }}>
              <div className="table-total-cell">
              <Body1Stronger>{formatDisplayDate(hours, dateToggle, true)}</Body1Stronger>
              </div>
            </TableCell>
          );
        })}
        <TableCell style={{ backgroundColor: "#F3F3F3" }}>
          <div className="table-total-cell">
          <Body1Stronger>{formatDisplayDate(tc.weekTotal, dateToggle, true)}</Body1Stronger>
          </div>
        </TableCell>
      </TableRow>
    ));
  }

  // Mobile Accordion
  return (
    <Accordion collapsible>
      {leaveProject.timecodes.map((tc, index) => (
        <AccordionItem key={`leave-${tc.timecodeName}`} value={`leave-${index}`}>
          <AccordionHeader className={mergeClasses(styles.accordionHeader)}>{`Leave - ${tc.timecodeName} - ${formatDisplayDate(tc.weekTotal, dateToggle, true)}`}</AccordionHeader>
          <AccordionPanel>
            {tc.dailyTotals.map((hours, i) => {
              const status = tc.statuses[i][0];
              const bgColour = getStatusColor(status);
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px",
                    marginBottom: "4px",
                    borderRadius: "4px",
                    backgroundColor: bgColour
                  }}
                >
                  <span>{dates[i].toDateString()}</span>
                  <Body1Stronger>{formatDisplayDate(hours, dateToggle, true) }</Body1Stronger>
                </div>
              );
            })}
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}